export const visit = (vm, at) => {
at({ "en": { "dealSplitsSidebar": { "title": "Deal Splits" }, "dealCollaboratorsSidebar": { "title": "Add collaborators" } } });
};